import type { MicrophonePermissionStatus } from './microphone-access.service';

/**
 * Custom error class for microphone access failures.
 * Used to distinguish microphone access errors from other errors in error handling.
 */
export class MicrophoneAccessError extends Error {
  constructor(
    message: string,
    public readonly originalError: unknown,
    public readonly permissionStatus: MicrophonePermissionStatus,
  ) {
    super(message);
    this.name = 'MicrophoneAccessError';
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, MicrophoneAccessError);
    }
  }
}
